/**
 * @generated SignedSource<<436c965c8498ea29bf60c236fe5ea8f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebarProjectForm_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedSelectProject_viewer">;
  readonly " $fragmentType": "CheckoutSidebarProjectForm_viewer";
};
export type CheckoutSidebarProjectForm_viewer$key = {
  readonly " $data"?: CheckoutSidebarProjectForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarProjectForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebarProjectForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSelectProject_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a4c32fbde5f1c774c35be16ac052b28c";

export default node;
